<script>
import SmartButton from "../SmartButton.vue";
import RequestCallInput from "./RequestCall/RequestCallInput.vue";

import fn from "@/helpers/func";

export default {
  props: {
    contentData: {
      type: Object
    }
  },
  components: { RequestCallInput, SmartButton },
  data() {
    return {
      errors: [],
      renderKey: 0,

      form: {
        fullName: {
          value: "",
          errorMessage: "",
          validationType: "name",
          required: true
        },

        phone: {
          value: "",
          errorMessage: "",
          validationType: "phone",
          required: true
        },
        date: {
          value: ""
        },
        time: {
          value: ""
        },
        radio: {
          value: "mobile"
        },

        validated: false,
        ///
        disabled: true,
        success: false
      }
    };
  },
  methods: {
    setSuccess() {
      this.form.success = false;
      setTimeout(() => {
        this.renderKey++;
      }, 500);
    },
    clearform() {
      this.errors = [];
      // this.form.success = false;
      this.form.fullName.value = "";
      this.form.phone.value = "";
      this.form.date.value = "";
      this.form.time.value = "";
      this.form.radio.value = "mobile";
      this.form.validated = false;
      this.form.disabled = true;

      for (const [key, val] of Object.entries(this.form)) {
        if (this.form[key].hasOwnProperty("errorMessage")) {
          this.form[key].errorMessage = "";
        }
      }

      this.widgets?.request_call?.checkboxes?.forEach(item => {
        this.form[item.tipHover] = false;
      });

      this.renderKey++;
    },
    async handleForm() {
      this.errors = [];
      const phoneFormat = new RegExp(
        /(^[0-9]+\d$|^\+[0-9]+\d$|^\d[0-9 \-]+\d$|^\+[0-9 \-]+\d$)/
      );
      const nameFormat = new RegExp(
        /(^[A-Za-zა-ჰ]{2,16})([ ]{1,})([A-Za-zა-ჰ]{2,16})/
      );

      for (const [key, val] of Object.entries(this.form)) {
        if (val["validationType"] === "phone") {
          let isRequired = this.form[key]?.required;
          if (isRequired === undefined) {
            isRequired = true;
          }

          const t = val.value.split(" ").join("");
          const phoneMatched = phoneFormat.test(t);

          if (!isRequired && !t) {
            this.form[key].errorMessage = "";
          } else {
            if (!phoneMatched) {
              this.form[key].errorMessage = fn.tr(
                "* Please type correct phone number"
              );
            } else {
              this.form[key].errorMessage = "";
            }
          }
        }

        if (val["validationType"] === "name") {
          const nameMatched = nameFormat.test(val.value);
          // const nameMatched = val.value?.length > 3;
          if (!nameMatched) {
            this.form[key].errorMessage = fn.tr("* Please type correct name");
          } else {
            this.form[key].errorMessage = "";
          }
        }
      }

      for (const [key, val] of Object.entries(this.form)) {
        if (
          this.form[key].hasOwnProperty("errorMessage") &&
          this.form[key].errorMessage.length
        ) {
          this.errors.push(this.form[key]?.errorMessage);
        }
      }

      if (!this.errors.length) {
        this.form.validated = true;
      } else {
      }
      if (!this.form.validated) return;

      function formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [day, month, year].join("-");
      }

      const sendForm = {
        formType: "RequestCall",
        fullName: this.form.fullName.value,
        phone: this.form.phone.value,
        contactForm: this.form.radio.value,
        contactDate:
          formatDate(this.form.date.value) + " " + this.form.time.value
      };

      this.widgets?.request_call?.checkboxes?.forEach(item => {
        sendForm[item.tipHover] = !!this.form?.[item.tipHover];
      });

      const response = await fn
        .postData("main/saveSubmitedForm", sendForm)
        .then(res => {
          if (res?.data[0] == "success") {
            this.form.success = true;
            this.clearform();
            setTimeout(() => {
              this.setSuccess();
            }, 5000);
          }
        });
    }
  },
  computed: {
    widgets() {
      let widgetItems = this.$store.state.main?.indx?.widgets;
      return { request_call: widgetItems.request_call };
    },
    taxonomyHours() {
      return _.get(this.$store.state.main, "indx.terms.available_hours");
    },
    minDate() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return d;
    }
  },

  watch: {
    form: {
      deep: true,
      handler(ns) {
        if (
          !!ns.fullName.value.length &&
          !!ns.phone.value.length &&
          !!ns.date.value &&
          !!ns.time.value &&
          !this.widgets?.request_call?.checkboxes?.some(x => !ns[x.tipHover])
        ) {
          this.form.disabled = false;
        } else {
          this.form.disabled = true;
        }
      }
    }
  }
};
</script>

<template>
  <div class="requestcall ">
    <div class="container">
      <div
        class="requestcall__banner"
        v-if="_.get(widgets.request_call, 'banner.length')"
      >
        <picture v-if="_.get(widgets.request_call, 'banner')">
          <source
            media="(max-width: 767px)"
            :srcset="_.get(widgets.request_call, 'banner.[0].devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(widgets.request_call, 'banner.[0].devices.tablet')"
          />
          <img
            :src="_.get(widgets.request_call, 'banner.[0].devices.desktop')"
            class="offer_img img-absolute"
            loading="lazy"
            alt
          />
        </picture>
      </div>
      <div class="requestcall__form">
        <div class="flex column wc">
          <el-form @submit.prevent>
            <RequestCallInput
              :labelText="$fn.tr('full name')"
              :errorMessage="form.fullName.errorMessage"
              required="true"
              @valueChanged="val => (form.fullName.value = val.target.value)"
              :key="`fullName-${renderKey}`"
            />
            <RequestCallInput
              :labelText="$fn.tr('tel')"
              required="true"
              type="number"
              :errorMessage="form.phone.errorMessage"
              @valueChanged="val => (form.phone.value = val.target.value)"
              :key="`tel-${renderKey}`"
            />

            <div class="requestcall__form-datebox">
              <div class="requestcall__form-dateinput relative wc">
                <v-date-picker
                  :popover="{ visibility: 'click' }"
                  mode="date"
                  :min-date="minDate"
                  :disabled-dates="{ weekdays: [1, 7] }"
                  v-model="form.date.value"
                >
                  <template v-slot="{ togglePopover, inputValue, inputEvents }">
                    <label
                      class="is-required"
                      :class="[
                        { focused: form.date.value || form.date.value.length }
                      ]"
                      >{{ $fn.tr("choose contact date") }}</label
                    >
                    <input
                      @click="() => togglePopover()"
                      class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300 "
                      :value="inputValue"
                      v-on="inputEvents"
                    />
                  </template>
                </v-date-picker>
              </div>
              <div class="requestcall__form-time">
                <select v-model="form.time.value" id="time" name="time">
                  <template v-for="(item, index) in taxonomyHours">
                    <option :value="item.title">{{ item.title }}</option>
                  </template>
                </select>
                <label
                  for="time"
                  class="is-required"
                  :class="[
                    { focused: form.time.value || form.time.value.length }
                  ]"
                  >{{ $fn.tr("choose time") }}</label
                >
              </div>
            </div>

            <div class="requestcall__form-checkboxes">
              <div class="requestcall__form-radio">
                <p class="requestcall__form-radio-title">
                  {{ $fn.tr("radiobuttons-text") }}
                </p>
                <el-radio v-model="form.radio.value" label="mobile">
                  {{ $fn.tr("mobile") }}</el-radio
                >
                <el-radio v-model="form.radio.value" label="whatsapp">{{
                  $fn.tr("whatsapp")
                }}</el-radio>
              </div>
              <div
                v-for="(item, index) in _.get(
                  widgets.request_call,
                  'checkboxes'
                )"
                :key="index"
              >
                <el-checkbox
                  v-model="form[item.tipHover]"
                  class="is-required"
                  >{{ item.tipText }}</el-checkbox
                >
              </div>
            </div>
          </el-form>

          <div :key="renderKey">
            <SmartButton
              :disabled="form.disabled"
              :class="[{ 'is-disabled': form.disabled }]"
              :title="$fn.tr('Submit')"
              background="#5f738b"
              color="#ffffff"
              class="requestcall__form-button"
              @click.native="handleForm"
            />
          </div>
          <transition name="toggleContent" mode="out-in">
            <div v-if="form.success" class="requestcall__form-success">
              {{ $fn.tr("Your massage sent sucsusfully") }}
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- <transition name="toggleContent" mode="out-in">
      <portal to="destination">
        <div class="success-modal-container" v-if="form.success">
          <div class="success-modal">
            <div class="success-modal-text">
              {{ $fn.tr("Your massage sent sucsusfully") }}
            </div>
            <svg
              @click="clearform"
              xmlns="http://www.w3.org/2000/svg"
              width="24.042"
              height="24.042"
              viewBox="0 0 24.042 24.042"
            >
              <g
                id="Group_6332"
                data-name="Group 6332"
                transform="translate(-2.979 2.021)"
              >
                <rect
                  id="Rectangle_543"
                  data-name="Rectangle 543"
                  width="30"
                  height="4"
                  rx="2"
                  transform="translate(5.808 -2.021) rotate(45)"
                  fill="#fff"
                />
                <rect
                  id="Rectangle_2206"
                  data-name="Rectangle 2206"
                  width="30"
                  height="4"
                  rx="2"
                  transform="translate(2.979 19.192) rotate(-45)"
                  fill="#fff"
                />
              </g>
            </svg>
          </div>
        </div>
      </portal>
    </transition> -->
  </div>
</template>

<style lang="scss">
.requestcall {
  padding-top: 70px;
  min-height: 100vh;
  background-color: var(--oppositeColor);
  @media (max-width: 1024px) {
    // padding-top: 100px;
  }
  &__banner {
    max-width: 626px;
    margin: 0 auto;
    height: 200px;
    position: relative;
    img {
      border-radius: 15px;
    }
  }
  &__form {
    padding-top: 50px;
    max-width: 626px;
    margin: 0 auto;
    margin-bottom: 290px;
    &-errormessage {
      margin-top: 16px;
      color: rgb(64, 216, 64);
      font-size: 18px;
      line-height: 24px;
    }
    &-radio {
      &-title {
        // margin-bottom: 8px;
        font-size: 14px;
        line-height: 19px;
      }
      label {
        margin-top: 8px;
      }
    }
    &-datebox {
      display: flex;
      width: 100%;
      gap: 16px;
      @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;
      }
    }
    &-dateinput {
      width: 100%;
      position: relative;
      margin-bottom: 16px;
      height: 72px;
      & .vc-day.in-month {
        span.is-disabled {
          opacity: 0.3;
        }
      }
      input {
        width: 100%;

        // width: 50%;
        padding-top: 29px;
        height: 64px;
        background-color: var(--primary);
        border: 1px solid var(--primary);
        color: var(--secondary);
        padding-left: 16px;
        font-size: 14px;
        line-height: 24px;
        border-radius: 4px;
        transition: all 0.11s cubic-bezier(0.6, 0, 0.4, 1);
        @media (max-width: 768px) {
          width: 100%;
        }
      }
      label {
        color: var(--secondary);

        font-size: 14px;
        line-height: 24px;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 16px;
        transition: all 0.11s cubic-bezier(0.6, 0, 0.4, 1);
        transform: translateY(20px);
        z-index: 3;
        pointer-events: none;
        max-width: calc(90% - 8px);
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        @media (max-width: 768px) {
          max-width: calc(100% - 16px);
        }
        &.is-required::after {
          content: "*";
          color: red;
          font-size: 14px;
          line-height: 24px;
        }
        &.focused {
          transform: translate(-9%, 10px) scale(0.84);
        }
      }
    }
    &-time {
      width: 100%;
      height: 72px;
      position: relative;
      margin-bottom: 16px;
      select {
        width: 100%;

        // width: 50%;
        padding-top: 29px;
        -webkit-appearance: none;
        height: 64px;
        background-color: var(--primary);
        border: 1px solid var(--primary);
        color: var(--secondary);
        padding-left: 16px;
        font-size: 14px;
        line-height: 24px;
        border-radius: 4px;
        transition: all 0.11s cubic-bezier(0.6, 0, 0.4, 1);
        outline: none;
        @media (max-width: 768px) {
          width: 100%;
        }
      }
      label {
        color: var(--secondary);

        font-size: 14px;
        line-height: 24px;
        position: absolute;
        z-index: -1;
        top: 0;
        left: 16px;
        transition: all 0.11s cubic-bezier(0.6, 0, 0.4, 1);
        transform: translateY(20px);
        z-index: 3;
        pointer-events: none;
        max-width: calc(90% - 8px);
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        @media (max-width: 768px) {
          max-width: calc(100% - 16px);
        }
        &.is-required::after {
          content: "*";
          color: red;
          font-size: 14px;
          line-height: 24px;
        }
        &.focused {
          transform: translate(-9%, 10px) scale(0.84);
        }
      }
    }

    &-button {
      width: 100% !important;
      &.is-disabled {
        cursor: not-allowed;
        background-color: #d1d5d6 !important;
        pointer-events: none;
      }
    }
    &-checkboxes {
      margin-bottom: 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      justify-content: center;

      .el-checkbox {
        display: flex;
        align-items: center;
        // width: max-content;
        &__inner {
          background-color: var(--primary) !important;
          border-color: #dcdfe6;
        }

        & .el-checkbox__label {
          white-space: wrap !important;
        }
        &.is-required {
          .el-checkbox__label::after {
            content: "*";
            color: red;
            font-size: 14px;
            line-height: 24px;
          }
        }
      }
    }
    &-success {
      padding-top: 16px;
      line-height: 19px;
      font-size: 14px;
      color: #ddffdd;
    }

    .line {
      display: flex;
      justify-content: center;
    }
  }
}

.success-modal-container {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.success-modal {
  background: #00a3e0;
  border-radius: 4px;
  min-width: 385px;
  padding: 0 25px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 480px) {
    min-width: unset;
    margin: 0 4px;
  }
}
.success-modal svg {
  cursor: pointer;
  margin-left: 20px;
}
</style>
